import { Controller } from "@hotwired/stimulus";

export default class DisableClick extends Controller {
  static values = {
    timeout: { type: Number, default: 20000 }
  };

  connect() {
    this.enableOnUpdate = () => this.enable();
    this.element.addEventListener("disable-click:enable", this.enableOnUpdate);
    // Turbo can restore a cached element that was disabled just before navigation.
    this.enable();
  }

  disable(event) {
    if (!this.enabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    this.enabled = false;

    this.element.classList.add("disabled");
    this.element.style.pointerEvents = "none";

    this.enableTimeout = setTimeout(() => {
      this.enable();
    }, this.timeoutValue);
  }

  disconnect() {
    this.element.removeEventListener("disable-click:enable", this.enableOnUpdate);
    this.enable();
  }

  enable() {
    if (this.enableTimeout) {
      clearTimeout(this.enableTimeout);
      this.enableTimeout = null;
    }

    this.enabled = true;
    this.element.classList.remove("disabled");
    this.element.style.pointerEvents = "";
  }
}
